import { Gto } from './gto'

export class BuscaGtoResponse{
    
    constructor(public nPagina?:number, public qtdPagina?:number, public listGto?:Array<Gto>){}

}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/buscaGtoResponse.ts